<p-table
  id="users-monitoring-table"
  [value]="usersData"
  [scrollable]="true"
  scrollDirection="horizontal"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template #header>
    <tr>
      <th
        class="!p-4"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.monitoring.details.table.NOMINATIVE | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.monitoring.details.table.LEVEL | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.monitoring.details.table.PLAN_TYPE | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.monitoring.details.table.MANDATORY | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.monitoring.details.table.STATUS | translate }}
        </span>
      </th>
      <th
        pFrozenColumn
        alignFrozen="right"
        class="relative text-center p-4 font-bold text-[var(--colors-gray-scale-black)]"
      >{{ TRANSLATION_KEYS.admin.ACTION | translate }}</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-user
  >
    <tr>
      <td
        class="!px-4 !py-3.5"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <div class="flex flex-row items-center gap-[10px]">
          <ape-avatar
            [image]="user.avatarImage"
            [forename]="user.forename"
            [surname]="user.surname"
            size="medium"
            shape="square"
            [attr.aria-hidden]="true"
            [withRing]="false"
            [variant]="'simple'"
          /><span class="font-normal text-[#000]">
            {{ user.surname + " " + user.forename }}
          </span>
        </div>
      </td>
      <td class="!px-4 !py-3.5">
        {{getPerformanceValueString(user.evaluationTalentMatrixBox)}}
      </td>
      <td class="!px-4 !py-3.5">
        {{user.scorecardType}}
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          [aspect]="'fill'"
          [kind]="getMandatoryStatusKind(user.isDevelopmentPlanMandatory)"
          [label]="getMandatoryString(user.isDevelopmentPlanMandatory)"
        />
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.developmentPlanStatus"
          [aspect]="'fill'"
          [kind]="getDevelopmentPlanStatusKind(user.developmentPlanStatus, user.isDevelopmentPlanMandatory)"
          [label]="getDevelopmentPlanStausLabel(user.developmentPlanStatus, user.isDevelopmentPlanMandatory)"
        />
      </td>
      <td
        pFrozenColumn
        alignFrozen="right"
        class="relative !text-center"
      >
        <ape-button
          style="position: relative;"
          [id]="'action-user-button-' + user.userId"
          class="my-0 mx-auto !w-8 !h-8"
          [cssClass]="'!w-8 !h-8'"
          size="small"
          aspect="icon"
          variant="primary"
          [rightIcon]="'assets/icons/ellipsis.svg'"
          [ariaLabel]="TRANSLATION_KEYS.admin.processSetup.table.ACCESS_PROCESS | translate"
          (buttonClick)="toggleActionColumn(user, $event)"
          [disabled]="!user.canAccessCalibration && !user.canImpersonateUser && !user.canImpersonateManager"
        />
      </td>
    </tr>
  </ng-template>
</p-table>

<ape-menu
  #apeMenu
  [menuItems]="menuItems"
/>